import {AziendaEditorProps} from "../Azienda.generalita.page";
import InputEx from "../../../components/wrapperComponents/InputEx";
import React, {useEffect, useMemo} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {useGetAziendeBancheQuery, useGetAziendeINAILQuery, useGetAziendeINPSQuery, useGetAziendeTabelleQuery} from "@commons/features/azienda/tabelle/aziendaMapping.api";
import ComboBoxAziende from "../../../components/comboBox/ComboBoxAziende";
import FormButtons from "../../../components/FormButtons";


const MappingAziendaEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource,onCancel,}) => {
    const {watch, register, getValues, setValue, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const initialValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);

    useEffect(() => {
        reset(initialValues);
    }, [resource]);

    // Contestualmente al Destructuring è possibile "modificare" il nome della variabile/const di destinzazione (Destructuring assignment)
    // Vedi:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment
    const {data: dataTabelle, isLoading: isLoadingTabelle} = useGetAziendeTabelleQuery({idAziendaMaster: resource.idAziendaMaster, idAzienda: resource.idAzienda});
    const {data: dataINPS, isLoading: isLoadingINPS} = useGetAziendeINPSQuery({idAziendaMaster: resource.idAziendaMaster, idAzienda: resource.idAzienda});
    const {data: dataINAIL, isLoading: isLoadingINAIL} = useGetAziendeINAILQuery({idAziendaMaster: resource.idAziendaMaster, idAzienda: resource.idAzienda});
    const {data: dataBanche, isLoading: isLoadingBanche} = useGetAziendeBancheQuery({idAziendaMaster: resource.idAziendaMaster, idAzienda: resource.idAzienda});

    return <>
        <form className="p-1">

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">ID "mapping"</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-3P">
                        <ComboBoxAziende<AziendaRecord> label="Id azienda tabelle" control={control} name="idAziendaCDIC" defaultValue={defaultValues.idAziendaCDIC} data={dataTabelle}
                                         isLoading={isLoadingTabelle}/>
                    </div>
                    <div className="sm1-3P">
                        <InputEx
                            label="Id azienda GAP"
                            name="idAziendaGAP"
                            register={register}
                            readOnly
                        />
                    </div>
                    <div className="sm1-3P">
                        <InputEx
                            label="Id azienda persona fisica o legale rappr."
                            name="idAziendaTLR"
                            register={register}
                            readOnly
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm1-3P">
                        <ComboBoxAziende<AziendaRecord> label="Id azienda INPS" control={control} name="idAziendaInps" defaultValue={defaultValues.idAziendaInps} data={dataINPS} isLoading={isLoadingINPS}/>
                    </div>
                    <div className="sm1-3P">
                        <ComboBoxAziende<AziendaRecord> label="Id azienda INAIL" control={control} name="idAziendaInail" defaultValue={defaultValues.idAziendaInail} data={dataINAIL}
                                         isLoading={isLoadingINAIL}/>
                    </div>
                    <div className="sm1-3P">
                        <ComboBoxAziende<AziendaRecord> label="Id azienda banche" control={control} name="idAziendaBanche" defaultValue={defaultValues.idAziendaBanche} data={dataBanche}
                                         isLoading={isLoadingBanche}/>
                    </div>
                </div>
            </fieldset>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Codifiche terze parti</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-4P">
                        <InputEx
                            label="Codice vs. paghe"
                            name="paghe.codAzienda"
                            register={register}
                            readOnly
                        />
                    </div>
                    <div className="sm1-4P">
                        <InputEx
                            label="Codice UL vs. paghe"
                            name="paghe.codUL"
                            register={register}
                            readOnly
                        />
                    </div>
                    <div className="sm1-4P">
                        <InputEx
                            label="Codice vs. HR"
                            name="hr.codAzienda"
                            register={register}
                            readOnly
                        />
                    </div>
                    <div className="sm1-4P">
                        <InputEx
                            label="Codice UL vs. HR"
                            name="hr.codUL"
                            register={register}
                            readOnly
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm1-4P">
                        <InputEx
                            label="Altra codifica azienda"
                            name="altraCodifica.codAzienda"
                            register={register}
                            readOnly
                        />
                    </div>
                    <div className="sm1-4P">
                        <InputEx
                            label="Altra codifica UL"
                            name="altraCodifica.codUL"
                            register={register}
                            readOnly
                        />
                    </div>
                    <div className="sm1-4P">
                        <InputEx
                            label="Codice vs fatturazione"
                            name="codFatturazione"
                            register={register}
                            readOnly
                        />
                    </div>
                </div>
            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>
    </>
}

export default MappingAziendaEditor;